/* eslint-disable global-require */
/* tslint:disable:no-require-imports no-var-requires */
import {Boot} from '@/project'

const fakeKakao = process.env.API_MODE === 'mock' ? require('./mock') : undefined

declare module 'vue/types/vue' {
  interface Vue {
    readonly $kakao: Kakao
    readonly $kakaoInit: () => void
  }
}

/**
 * Kakao js SDK
 * there is a global Kakao variable. see src/index.pug
 * Kakao company doesn't support es module of JS SDK (poor company) so we should use a cdn file link
 * Instead see src/index.pug
 * @param Vue
 */
const boot: Boot = ({Vue}) => {
  if(!Kakao) {
    throw new Error('[kakao] Kakao must exist in global (window)')
  }

  if(fakeKakao) {
    fakeKakao.init(process.env.KAKAO_API_KEY)
    Vue.prototype.$kakao = fakeKakao.default
    Vue.prototype.$kakaoInit = () => {
      // empty
    }
  } else {
    Kakao.init(process.env.VUE_APP_KAKAO_API_KEY)
    Vue.prototype.$kakao = Kakao
    Vue.prototype.$kakaoInit = () => {
      Kakao.cleanup()
      Kakao.init(process.env.VUE_APP_KAKAO_API_KEY)
    }
  }
}

export default boot
